import { render, staticRenderFns } from "./ListOcurrences.vue?vue&type=template&id=619e9d39"
import script from "./ListOcurrences.vue?vue&type=script&lang=js"
export * from "./ListOcurrences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports